export const BASE_URL = process.env.REACT_APP_BASE_URL;
// export const BASE_URL = 'http://192.168.31.94:8000/api/v1/';
export const BASE_URL_IMAGE = process.env.REACT_APP_BASE_URL_IMAGES;

export const API_END_POINTS = {
  /////////////////////////////<===MUTATIONS===>//////////////////////////////
  registerUser: BASE_URL + "auth/signup",
  loginUser: BASE_URL + "auth/signin",
  addPackingList: BASE_URL + "packing-list",
  destinationPopup: BASE_URL + "destination",
  blockPacking: BASE_URL + "packing-list/block",
  duplicatePacking: BASE_URL + "packing-list/duplicate",
  blockTraveller: BASE_URL + "user/block/",
  addUpdatetag: BASE_URL + "tag",
  savePackingList: BASE_URL + "packing-list/save/",
  unSavePackingList: BASE_URL + "packing-list/unsave/",
  readNotification: BASE_URL + "notifications/read/ ",
  packingStatus: BASE_URL + "packing-list/status",
  packingDefault: BASE_URL + "packingListDefaults",
  addPrimaryBadge: BASE_URL + "badges/primary",
  addSpecialBadge: BASE_URL + "badges/special",
  deleteBadges: BASE_URL + "badges/",
  assignPrimaryBadge: BASE_URL + "badges/assign/primary/",
  assignSpecialBadge: BASE_URL + "badges/assign/special/",
  assignPoints: BASE_URL + "badges/user/",

  /////////////////////////////<===QUERIES===>////////////////////////////////
  getProducts: BASE_URL + "product",
  getAuthUser: BASE_URL + "auth/check",
  getDestination: BASE_URL + "destination/all",
  getTags: BASE_URL + "tag",
  getPackingListSearch: BASE_URL + "packing-list/all",
  getPackingListById: BASE_URL + "packing-list",
  getPackingListSearh: BASE_URL + "packing-list",
  // getPackingListSearh: BASE_URL + "packing-list/getFilteredPackingLists",
  getDashboardSearch: BASE_URL + "dashboard",
  getDashboardStats: BASE_URL + "packing-list/summary",

  getProfileDistribution: BASE_URL + "user/profiles-by-country-gender",
  getCitiesPerCountry: BASE_URL + "destination/stats",
  getTravellerProfileTable: BASE_URL + "user/get",
  getPackingListStatsCard: BASE_URL + "packing-list/stats",
  getSpendingMetrics: BASE_URL + "orders/spend-this-month",
  getDashboardTable: BASE_URL + "orders/users/orders",
  getPackingListAnalytics: BASE_URL + "packing-list/packinglisttypesgraph",
  getDestinationAnalytics: BASE_URL + "destination/destination-analytics",
  getMonthlyGrowthRate: BASE_URL + "user/profiles-count-by-month",
  getActivityDistribution: BASE_URL + "packing-list/activity-distribution",
  getNationalityComposition: BASE_URL + "user/nationality-composition",
  getPackingStyleDistribution:
    BASE_URL + "packing-list/packing-style-distribution",
  getTechItems: BASE_URL + "packing-list/tech-item-distribution",
  getToiletryDistribution: BASE_URL + "packing-list/toiletry-distribution",
  getActivity: BASE_URL + "packing-list/activity-distribution",
  getOrderedBySaves: BASE_URL + "packing-list/ordered-by-saves",
  getFilter: BASE_URL + "user/monthly-growth",
  getTravellState: BASE_URL + "user/traveller-statistics",
  UpdateProfile: BASE_URL + "user/update-profile",
  countsavedlist: BASE_URL + "packing-list/countsavedlist",
  getSavedPackingList: BASE_URL + "packing-list/saved",
  getAllNotification: BASE_URL + "notifications/notifications",
  getUnReadAllNotification: BASE_URL + "notifications/notifications/unread",
  getTopTenPacking: BASE_URL + "packing-list/top-saved",
  partialPacking: BASE_URL + "packing-list/latest-packinglists",
  perfectPacking: BASE_URL + "packing-list/saved",
  topSection: BASE_URL + "top-section/68243fd4b74de2678da83b73",
  getTopSection: BASE_URL + "top-section",
  getUserById: BASE_URL + "user",
  primaryBadges: BASE_URL + "badges/primary",
  specialBadges: BASE_URL + "badges/special",
  genderPacking: BASE_URL + "dashboard/gender-stats",
};    